import React from 'react';

import PropTypes from 'prop-types';

import MultiSelect from './multiSelect';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const FilterByStatus = ({ filters, setFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    BUSINESS_APP_ORDERS: { filterByStatus, statusFilters }
  } = localizedStrings;

  return (
    <div>
      <MultiSelect
        label={filterByStatus}
        options={statusFilters.map(item => ({
          label: item.text,
          value: item.value
        }))}
        value={filters.status}
        updateFilters={value => setFilters({ ...filters, status: value })}
      />
    </div>
  );
};

FilterByStatus.propTypes = {
  filters: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  setFilters: PropTypes.func.isRequired
};

export default FilterByStatus;
